<match-display-wrapper
    matchLabel="{{ l10nKeys.clientClassLabel | vtranslate }}"
    matchCriteria="{{ editable.config.op | enumValueLabel : 'MatchOperation' }}"
>
    <div *ngFor="let class of classTexts; trackBy: trackByIndex">
        {{ class }}
    </div>
</match-display-wrapper>
